// src/modules/notifications/notificationApi.ts
import httpService from "../../services/httpService";

export interface NotificationTarget {
  type: "all" | "user" | "segment";
  value: string | null;
  language?: "english" | "turkish";
}

export interface SendNotificationPayload {
  title: string;
  body: string;
  data?: Record<string, any>;
  target: NotificationTarget;
  dryRun?: boolean;
}

export interface CampaignPayload extends SendNotificationPayload {}

export async function sendNotification(payload: SendNotificationPayload) {
  try {
    const response = await httpService.postRaw("/notifications/send", payload);
    return response.data;
  } catch (error: any) {
    // Hata ve rate limit yönetimi
    if (error.response?.status === 429) {
      throw new Error("Çok sık istek atıldı. Lütfen daha sonra tekrar deneyin.");
    }
    if (error.response?.data?.error) {
      throw new Error(error.response.data.error);
    }
    throw error;
  }
}

export async function startCampaign(payload: CampaignPayload) {
  try {
    const response = await httpService.postRaw("/notifications/campaigns/", payload);
    return response.data;
  } catch (error: any) {
    if (error.response?.status === 429) {
      throw new Error("Rate limit aşıldı.");
    }
    throw error;
  }
}

export async function getCampaignStatus(campaignId: string) {
  try {
    const response = await httpService.getRaw(`/notifications/campaigns/${campaignId}`);
    return response.data;
  } catch (error: any) {
    throw error;
  }
}
